import React from 'react';
import {  Route, Routes  } from 'react-router-dom';
import Card from '../Card/Card';
import Logistic from './Logistic/Logistic';
import Food from './Food/Food';
import Travel from './Travel/Travel';
import Associate from './Associate/Associate.js';
import Ecommerce from './Ecommerce/Ecommerce';
import Realestate from './Realestate/Realestate';

function Main() {
  return (
    <>
      <Routes >
        <Route path="/" element={<Card/>} />
        <Route path="logistic" element={<Logistic/>} />
        <Route path="food" element={<Food/>} />
        <Route path="traveling" element={<Travel/>} />
        <Route path="associate" element={<Associate/>} />
        <Route path="ecommerce" element={<Ecommerce/>} />
        <Route path="realestate" element={<Realestate/>} />
      </Routes >
    </>
  );
}

export default Main;
